import { useMemo } from 'react';

const usePagesWithExternalLinks = ({ pages, externalLinks }) => {
  const getFlatExternalLinks = (externalLinks, parentTitle) => {
    return externalLinks.reduce((acc, { permission, title, children }) => {
      if (children) {
        return [...acc, ...getFlatExternalLinks(children, title)];
      }

      if (!permission) {
        return acc;
      }

      return [
        ...acc,
        {
          id: permission,
          name: `${parentTitle} / ${title}`,
        },
      ];
    }, []);
  };

  return useMemo(() => {
    return externalLinks?.length
      ? [...pages, ...getFlatExternalLinks(externalLinks)]
      : pages;
  }, [externalLinks, pages]);
};

export default usePagesWithExternalLinks;
